import "../App.css";
import React from "react";

import placeHolderDoc from "../imgs/placeholder-doc.svg";
import placeHolderVid from "../imgs/placeholder-vid.svg";
import doc from "../imgs/document.png";
import dude from "../imgs/support-banner.svg";

import Troubleshooting from "../components/troubleshooting"

import Helmet from "react-helmet";
 
import image from "../imgs/image.jpg";

import network from "../imgs/network-icon-white.svg";

const Detail = (props) => {
  return (
    <div className="details-wrapper">
      {props.resource ? (
        props.resource.type == "video" ? (
          <div className="video-wrapper">
            <iframe
              src={
                "https://player.vimeo.com/video/" +
                props.resource.url.split("/")[
                  props.resource.url.split("/").length - 1
                ]
              }
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen=""
            ></iframe>
          </div>
        ) : (
          <div className="doc-wrapper">
            <img src={doc} />
          </div>
        )
      ) : (
        <div className="spinner">
          <span>
            <span>loading</span>
            <br />
            <span>•</span>
            <span>•</span>
            <span>•</span>
          </span>
        </div>
      )}

      {props.resource ? (
        <div className="content">
          <h2>{props.title}</h2>
          <p>{props.resource.description}</p>

          {props.resource.type == "video" ? (
            ""
          ) : (
          <a href={props.resource.url} target="_blank" style={{textDecoration:"none"}}><button className="flat-button doc-cta">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 17 21"
              >
                <g>
                  <path
                    class="st0"
                    d="M2.5,0.5c-1.1,0-2,0.9-2,2l0,16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-12l-6-6H2.5z"
                  />
                  <polygon class="st1" points="9.5,7.5 9.5,2 15,7.5 	" />
                </g>
              </svg>
              Read Document
            </button></a>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

class GettingStarted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "System Requirements",
      filter1: "general",
      filter2: "all",
    };
  }
 

  componentDidMount() {}

  handleFilter1(event) {
    this.setState({
      filter1: event.target.value,
    });
  }

  handleFilter2(event) {
    this.setState({
      filter2: event.target.value,
    });
  }

  render() {
    return (
      <>
      <Helmet>
        <meta name="description" content="Manage your Project Ares account, submit a support ticket, and explore use tips for Players and Trainers. " />
 
 
        <meta property="og:locale" content="en_US" />
 
        <meta property="og:title" content="Support | Project Ares Resource Center  " />
        <meta property="og:description" content="Manage your Project Ares account, submit a support ticket, and explore use tips for Players and Trainers." />
 
        <meta property="og:site_name" content="Support | Project Ares Resource Center " />
        <meta property="og:image" content={image} />
        <meta property="og:image:secure_url"  content={image} />
        <meta property="og:image:width" content="1280" />
        <meta property="og:image:height" content="720" />
        <link rel="canonical" href="https://projectares.academy/support" />
 
      </Helmet>
        <div className="support-hero">
          <h1>Project Ares Customer Support</h1> <img src={dude} />
        </div>
        <div className="support">
          <div className="left">
            <div className="contact-wrapper">
              <div className="top">
                {" "}
                <h3>Contact Us</h3>{" "}
                <span>
                  Monday - Friday
                  <br />
                  7am - 7pm EST
                </span>{" "}
              </div>
              <p>
                To reach us quickly and have your question tracked in our
                system, please complete the Contact Support form.
              </p>
          
              <p> Additional ways to reach us:</p>
              <div className="bottom">
                <span>
                  Phone number:
                  <br />
                  <a href="tel:303-412-8800">303.412.8800</a>
                </span>
                <span>
                  Customer support:
                  <br />
                  <a href="mailto:csd@circadence.com">csd@circadence.com</a>
                </span>
              </div>
            </div>
            <a href="https://projectares.academy/schedule-a-demo-consultation" className="form" target="_blank">   <button> 
<svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"  viewBox="0 0 93.3 126.3" >

<g>
	<path class="st0" d="M12.9,7.2L0,21.5l0.5,102.4c0,1.5,1.2,2.5,2.6,2.4l87.6-8.1c1.4-0.1,2.6-1.4,2.6-2.9L92.7,2.4
		c0-1.5-1.2-2.5-2.6-2.4L12.9,7.2z"/>
	<g>
		<path class="st1" d="M11.8,21.3c1.2-0.1,2.1-1.2,2.1-2.3L13.2,7.2L0,21.8L11.8,21.3z"/>
		<polygon class="st1" points="12.9,7.2 0,21.5 0,21.8 13.2,7.2 		"/>
	</g>
	<path class="st2" d="M13,18.3L12.9,7.2L0,21.5l11-1C12.1,20.4,13,19.4,13,18.3z"/>
	<g>
		<polygon class="st2" points="48.4,26.2 52.1,25.8 51.4,24.2 49.9,24.2 50.3,21.4 49.5,19.3 		"/>
		<polygon class="st2" points="48.3,18.9 46.9,18.4 47.8,22.6 		"/>
		<polygon class="st2" points="46.8,35.7 48.3,34.8 47.9,31.1 		"/>
		<polygon class="st2" points="45.3,18.2 43.9,20.6 45.2,24.5 41.8,24.4 40.4,26.9 47.7,26.2 		"/>
		<polygon class="st2" points="48.5,27.3 52.1,27 51.5,28.7 50,29 50.4,31.8 49.6,34 		"/>
		<polygon class="st2" points="45.4,35.8 44.1,33.8 45.3,29.6 41.5,29.9 40.4,28 47.7,27.3 		"/>
	</g>
	<g>
		<path class="st3" d="M35.6,44.6l-8,0.7c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l8-0.7c0.6-0.1,1,0.4,1,0.9l0,0
			C36.6,44,36.1,44.5,35.6,44.6z"/>
		<path class="st3" d="M50.3,43.2l-8,0.7c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l8-0.7c0.6-0.1,1,0.4,1,0.9v0
			C51.3,42.7,50.9,43.2,50.3,43.2z"/>
		<path class="st3" d="M65.1,41.8l-8,0.7c-0.6,0.1-1-0.4-1-0.9v0c0-0.6,0.4-1.1,1-1.1l8-0.7c0.6-0.1,1,0.4,1,0.9v0
			C66.1,41.3,65.6,41.8,65.1,41.8z"/>
		<path class="st3" d="M65.1,49.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9l0,0
			C66.1,49.3,65.7,49.8,65.1,49.8z"/>
		<path class="st3" d="M65.2,57.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9v0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9v0
			C66.2,57.3,65.7,57.8,65.2,57.8z"/>
		<path class="st3" d="M65.2,65.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9l0,0
			C66.2,65.3,65.8,65.8,65.2,65.8z"/>
		<path class="st3" d="M65.2,73.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9v0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9l0,0
			C66.2,73.3,65.8,73.8,65.2,73.8z"/>
		<path class="st3" d="M65.3,81.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9v0
			C66.3,81.3,65.8,81.8,65.3,81.8z"/>
		<path class="st3" d="M65.3,89.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9l0,0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9l0,0
			C66.3,89.3,65.9,89.8,65.3,89.8z"/>
		<path class="st3" d="M65.4,97.8l-37.5,3.5c-0.6,0.1-1-0.4-1-0.9v0c0-0.6,0.4-1.1,1-1.1l37.5-3.5c0.6-0.1,1,0.4,1,0.9l0,0
			C66.4,97.3,65.9,97.8,65.4,97.8z"/>
	</g>
	<polygon class="st2" points="52.6,107.7 40.8,108.8 40.8,105.1 52.6,104 	"/>
</g>
</svg>
Fill out our support form</button></a>
          </div>
          
          <div className="right">
         
         {/*   <div className="account-wrapper">
           <div> <h3>Account Management</h3></div>  
           <div><a href="https://cyberbridge2.circadence.com/login"><button>LOG IN TO PROJECT ARES</button></a>   <a href="https://circadence.com/cancel-subscription"><button>Cancel Subscription</button></a></div>  
    </div>*/}

<Troubleshooting button=  { <div style={{pointerEvents:"none"}}> <div className="content-item">
                        
                   <img src={network}/>     <span>Test Your Connection to Project Ares</span>
                                
                      </div></div>}/>

        <a href="https://news.projectares.academy/blog/living-our-mission-delivering-exceptional-customer-support/" target="_blank" style={{textDecoration:"none"}}>  <button className="meet-team"> 
<svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"  viewBox="0 0 233.7 208.1"   >

 
<g>
	<path class="st0" d="M228.3,10c0-2-0.6-3.9-1.6-5.4l1.3-0.6l-4.4-2.5c-0.3-0.2-0.5-0.3-0.8-0.5L222.8,1v0c-1.6-0.8-3.4-1.1-5.4-0.9
		L10.8,19.9c-6,0.6-10.8,6-10.8,12l1.4,164c0.1,6.1,5,10.5,11,9.9L218.9,186c6-0.6,10.8-6,10.8-12L228.3,10z"/>
	<path class="st1" d="M222.9,188.2L16.3,208.1c-6,0.6-10.9-3.9-11-9.9L4,34.1c-0.1-6.1,4.8-11.4,10.8-12L221.4,2.3
		c6-0.6,10.9,3.9,11,9.9l1.4,164C233.8,182.3,228.9,187.7,222.9,188.2z"/>
	<path class="st2" d="M224.2,182.4L15,202.4c-2.2,0.2-4-1.4-4-3.6L9.7,51.7c0-2.2,1.8-4.2,4-4.4l209.1-20.1c2.2-0.2,4,1.4,4,3.6
		l1.2,147.1C228.1,180.2,226.4,182.2,224.2,182.4z"/>
	<g>
		<ellipse transform="matrix(0.653 -0.7574 0.7574 0.653 -22.2905 21.578)" class="st3" cx="12.4" cy="35.1" rx="2.9" ry="2.7"/>
		<ellipse transform="matrix(0.653 -0.7574 0.7574 0.653 -18.0237 28.9384)" class="st4" cx="22.6" cy="34.1" rx="2.9" ry="2.7"/>
		<ellipse transform="matrix(0.653 -0.7574 0.7574 0.653 -13.7569 36.2988)" class="st5" cx="32.7" cy="33.2" rx="2.9" ry="2.7"/>
		<path class="st6" d="M224,17.6L45.4,34.8c-1.5,0.1-2.8-1-2.8-2.6v0c0-1.6,1.2-2.9,2.8-3.1L223.9,12c1.5-0.1,2.8,1,2.8,2.6v0
			C226.7,16.1,225.5,17.5,224,17.6z"/>
	</g>
	<path class="st3" d="M214.6,78L22.8,96.4c-1.7,0.2-3-1.1-3-2.7L19.5,58c0-1.7,1.3-3.1,3-3.3l191.8-18.4c1.7-0.2,3,1.1,3,2.7
		l0.3,35.7C217.6,76.4,216.3,77.9,214.6,78z"/>
	<g>
		<polygon class="st7" points="42.6,72.4 48.2,71.9 47.2,69.4 44.9,69.4 45.5,65.1 44.2,61.9 		"/>
		<polygon class="st7" points="42.4,61.3 40.3,60.5 41.7,67 		"/>
		<polygon class="st7" points="40.2,86.8 42.5,85.6 41.8,79.9 		"/>
		<polygon class="st7" points="37.8,60.3 35.7,63.9 37.8,69.8 32.5,69.7 30.3,73.6 41.5,72.5 		"/>
		<polygon class="st7" points="42.7,74.1 48.3,73.6 47.3,76.2 45,76.7 45.7,80.9 44.5,84.3 		"/>
		<polygon class="st7" points="38.1,87 36.1,84.1 37.9,77.6 32.1,78 30.4,75.2 41.6,74.2 		"/>
	</g>
	<path class="st7" d="M95.4,61l-33.3,3.2c-1.1,0.1-2-0.7-2-1.9v0c0-1.1,0.9-2.1,2-2.2L95.4,57c1.1-0.1,2,0.7,2,1.9v0
		C97.5,59.9,96.6,60.9,95.4,61z"/>
	<path class="st7" d="M109.9,69.2l-47.7,4.6c-1.1,0.1-2-0.7-2-1.9v0c0-1.1,0.9-2.1,2-2.2l47.7-4.6c1.1-0.1,2,0.7,2,1.9v0
		C112,68.1,111.1,69.1,109.9,69.2z"/>
	<path class="st7" d="M86.6,81l-24.3,2.3c-1.1,0.1-2-0.7-2-1.9v0c0-1.1,0.9-2.1,2-2.2l24.3-2.3c1.1-0.1,2,0.7,2,1.9v0
		C88.6,79.9,87.7,80.9,86.6,81z"/>
	<path class="st8" d="M78.6,138.6L22.7,144c-1.4,0.1-2.6-0.9-2.6-2.3l-0.3-33.4c0-1.4,1.1-2.7,2.5-2.8l55.8-5.4
		c1.4-0.1,2.6,0.9,2.6,2.3l0.3,33.4C81.1,137.2,80,138.5,78.6,138.6z"/>
	<path class="st8" d="M214.9,92.6L91.1,104.5c-1.5,0.1-2.8-1-2.8-2.5v0c0-1.6,1.2-2.9,2.8-3.1L214.9,87c1.5-0.1,2.8,1,2.8,2.5v0
		C217.7,91.1,216.5,92.5,214.9,92.6z"/>
	<path class="st8" d="M134.1,110.8L91.2,115c-1.5,0.1-2.8-1-2.8-2.5v0c0-1.6,1.2-2.9,2.8-3.1l42.8-4.1c1.5-0.1,2.8,1,2.8,2.5v0
		C136.9,109.3,135.6,110.7,134.1,110.8z"/>
	<path class="st9" d="M216.5,112.2L89.9,124.4c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l126.6-12.2
		c0.8-0.1,1.4,0.5,1.4,1.3l0,0C217.9,111.4,217.3,112.1,216.5,112.2z"/>
	<path class="st9" d="M208.5,119.6L90,130.9c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l118.5-11.4
		c0.8-0.1,1.4,0.5,1.4,1.3v0C209.9,118.8,209.3,119.5,208.5,119.6z"/>
	<path class="st9" d="M211.9,125.8L90,137.5c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5L211.8,123c0.8-0.1,1.4,0.5,1.4,1.3
		l0,0C213.3,125.1,212.6,125.8,211.9,125.8z"/>
	<path class="st9" d="M216.7,136l-195,18.7c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l195-18.7c0.8-0.1,1.4,0.5,1.4,1.3v0
		C218.1,135.2,217.5,135.9,216.7,136z"/>
	<path class="st9" d="M196.7,145.2L21.7,162c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l175-16.8c0.8-0.1,1.4,0.5,1.4,1.3
		l0,0C198.1,144.5,197.5,145.2,196.7,145.2z"/>
	<path class="st9" d="M210.9,151.2L21.8,169.4c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l189.1-18.2
		c0.8-0.1,1.4,0.5,1.4,1.3l0,0C212.3,150.5,211.7,151.1,210.9,151.2z"/>
	<path class="st9" d="M202,159.4L21.9,176.7c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l180.1-17.3
		c0.8-0.1,1.4,0.5,1.4,1.3l0,0C203.4,158.7,202.7,159.4,202,159.4z"/>
	<path class="st9" d="M214.7,165.6L21.9,184.1c-0.8,0.1-1.4-0.5-1.4-1.3v0c0-0.8,0.6-1.5,1.4-1.5l192.8-18.5
		c0.8-0.1,1.4,0.5,1.4,1.3l0,0C216.1,164.8,215.5,165.5,214.7,165.6z"/>
	<path class="st9" d="M217,172.7L22,191.4c-0.8,0.1-1.4-0.5-1.4-1.3l0,0c0-0.8,0.6-1.5,1.4-1.5l195-18.7c0.8-0.1,1.4,0.5,1.4,1.3
		l0,0C218.4,171.9,217.8,172.6,217,172.7z"/>
</g>
</svg>
<span>Meet the Customer Support Team</span></button></a>
          </div>
        </div>

        <hr />
        <div className="knowledge-base-wrapper">
          {this.props.resources ? (
            <>
              <div className="left-col">
                <div
                  className={
                    "intro " + this.state.filter2 + " " + this.state.filter1
                  }
                >
                  <h2>{this.props.title}<button onClick={(event)=>{event.target.parentNode.parentNode.classList.toggle('clicked')}} className="list-toggle">▼
                    
                    
                    
                    </button></h2>

                  <div className="filters">
                    <h5>Filter by:</h5>
                    <div>
                      <span
                        style={{ display: "inline-block", margin: "0 1em 0 0" }}
                      >
                        User:
                      </span>
                      <select
                        value={this.state.filter1}
                        onChange={(event) => this.handleFilter1(event)}
                      >
                        <option value="general">All</option>
                        <option value="player">Player</option>
                        <option value="trainer">Trainer</option>
                     {  /* <option value="admin">Customer Admin</option>*/}
                      </select>
                    </div>
                    <div>
                      <span
                        style={{ display: "inline-block", margin: "0 1em 0 0" }}
                      >
                        File Type:
                      </span>
                      <select
                        value={this.state.filter2}
                        onChange={(event) => this.handleFilter2(event)}
                      >
                        <option value="all">All Files</option>
                        <option value="videos">Videos</option>
                        <option value="documents">Documents</option>
                      </select>
                    </div>
                  </div>
                </div>
                <ul className="resources">
                  {Object.keys(this.props.resources)
                    .sort((a, b) =>
                      this.props.resources[a].step >
                      this.props.resources[b].step
                        ? 1
                        : -1
                    )
                    .map((key, index) => {
                      return (
                        <li
                          className={
                            "resource " +
                            this.props.resources[key].type +
                            (this.state.active == key ? " active " : " ") +
                            this.props.resources[key].user
                          }
                          key={key}
                          onClick={() => {
                            this.setState({ active: key });
                          }}
                        >
                          <div className="thumbnail">


                          {this.props.resources[key].type == "video" ? (
                                   <img src={placeHolderVid} />
                              ) : (
                                <img src={placeHolderDoc} />
                              )}
 
                          </div>{" "}
                          <div className="content">
                            <h4>{key}</h4>
                            <div className="icons-wrapper">
                              <span> {this.props.resources[key].user=="player trainer" && this.state.filter1=="player"?"player":this.props.resources[key].user=="player trainer"?"trainer":this.props.resources[key].user}</span>
                              {/*this.props.resources[key].type == "video" ? (   <PlayIcon />     ) : (   <DocIcon />    )*/}
                            </div>
                            <p>{this.props.resources[key].description}</p>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </div>
              <div className="right-col">
                <Detail
                  resource={this.props.resources[this.state.active]}
                  title={this.state.active}
                />
              </div>
            </>
          ) : (
            <div className="spinner">
              <span>
                <span>loading</span>
                <br />
                <span>•</span>
                <span>•</span>
                <span>•</span>
              </span>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default GettingStarted;
